// Quem vai sair na LINHA DE ASSINATURA do PDF de um expediente ainda sem envelope.
//
// 🚨 Espelha a regra do pdf-generator (`dre-sistema/lambda/pdf-generator/index.js`,
//    bloco "Bloco de assinatura"): sem envelope, assina quem está marcado como
//    "Assina" em "Quem participa"; se ninguém estiver marcado, assina o AUTOR.
//    O teste `comercial-engine/tests/expedientes/quem-assina.test.js` trava as duas.
//
// Por que a tela precisa dizer isso (30/09/2026): a DEC-2026-002 foi finalizada
// só com o autor em "Quem participa". O texto falava do Lucas, o PDF saiu com o
// nome do Gustavo na linha e o documento teve de ser cancelado ("Foi feito com o
// nome errado do assinante"). A regra estava certa, mas ninguém enxergava que o
// autor era o assinante por omissão.
//
// O corpo da função não leva anotação de tipo: o teste a executa extraída do .ts.
import type { Envolvido } from './api';

export function assinantesPrevistos(envolvidos: Envolvido[] | undefined): { quem: Envolvido[]; peloAutor: boolean } {
  const lista = envolvidos || [];
  const declarados = lista.filter(function (e) { return e.papel === 'signatario'; });
  if (declarados.length) return { quem: declarados, peloAutor: false };
  return { quem: lista.filter(function (e) { return e.papel === 'autor'; }), peloAutor: true };
}
